'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M267 4.3l-10.9-10.2-10.9 10.2-240 224-11.7 10.9 21.8 23.4c6.2-5.8 17.2-16 32.8-30.6l0 280 416 0 0-280c15.6 14.6 26.5 24.8 32.8 30.6l21.8-23.4c-2.6-2.4-20.8-19.4-54.6-51l0-156.2-112 0 0 51.7-85.1-79.4zM432.1 202.2l0 277.8-96 0 0-176-160 0 0 176-96 0 0-277.8 176-164.3 176 164.3zM208.1 480l0-144 96 0 0 144-96 0zm224-416l0 94.4-48-44.8 0-49.6 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;